import { buildCommunityIconPublicUrl } from './build-community-icon-public-url';
import { normalizeCacheBustTimestamp } from './normalize-cache-bust-timestamp';

/** コミュニティアバター表示用。`iconUrl` は公開 URL（未設定は null）。 */
export function toCommunityAvatarSource(
  supabaseUrl: string,
  community: {
    id: string;
    name: string;
    iconPath?: string | null;
    iconUpdatedAt?: string | Date | null;
  },
): { id: string; name: string; iconUrl: string | null } {
  return {
    id: community.id,
    name: community.name,
    iconUrl: buildCommunityIconPublicUrl(
      supabaseUrl,
      community.iconPath,
      normalizeCacheBustTimestamp(community.iconUpdatedAt),
    ),
  };
}
